import Form from '../components/Form';
import Title from '../components/Title';

export default ({advertiser, category, ...props}) => {
    return <div className="pt-2">
        <hr className="mb-4"/>
        <p className="mb-3">
            <Title advertiser={advertiser} category={category}/>
        </p>
        <div className="row">
            <div className="col-12 col-sm-10 col-md-7 m-auto">
                <Form advertiser={advertiser} category={category} {...props} />
            </div>
        </div>
    </div>
}
